export function performanceLog(message) {
    window.performance && console.info('performanceLog:' + message, window.performance.now());
}
